import type { ChangeEvent, InputHTMLAttributes, KeyboardEvent } from "react";
import type { SpaceProps } from "styled-system";

export enum inputIcon {
  SEARCH = "search",
}

export const inputIcons = {
  SEARCH: "search",
} as const;

export type IconVariants = (typeof inputIcons)[keyof typeof inputIcons];

type InputTypes = InputHTMLAttributes<HTMLInputElement>;

export type InputProps = {
  id: string;
  name: string;
  placeholder: string;
  icon: boolean;
  label?: string;
  iconPosition?: "left" | "right";
  iconBackground?: boolean;
  iconGreyColored?: boolean;
  iconVariant?: IconVariants;
  value?: string;
  defaultValue?: string | number | null;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  focused?: boolean;
  error?: boolean;
  errorHelper?: any;
  helperText?: string | null;
  validated?: boolean;
  multiline?: boolean;
  rows?: number;
  disabled?: boolean;
  autoComplete?: string;
  size?: "small";
  onClick?: () => void;
  type?: "text" | "password";
  mask?: string;
  max?: number;
  min?: number;
  variant?: "default" | "backgroundOnly";
  className?: string;
} & InputTypes &
  SpaceProps;
